import { Component, inject } from '@angular/core';
import { SchedulerHolderComponent } from '../../scheduler-components/scheduler-holder/scheduler-holder.component'


@Component({
    selector: 'app-scheduler-page',
    imports: [SchedulerHolderComponent],
    templateUrl: './scheduler-page.component.html',
    styleUrl: './scheduler-page.component.css'
})
export class SchedulerPageComponent {

}
